import { useGetAllExamCoursesQuery } from '@report/graphql';
import { FormSearchSelection, type FormSearchSelectionProps } from '@shared/components';
import { useMemo } from 'react';
import { type FieldValues } from 'react-hook-form';

interface ExamCourseSearchSelectionProps
  extends Pick<FormSearchSelectionProps<FieldValues>, 'name' | 'placeholder'> {
  multiple?: boolean;
}

export default function ExamCourseSearchSelection(props: Readonly<ExamCourseSearchSelectionProps>) {
  const { name, placeholder } = props;

  const { data: examCourseData, loading: isLoadingExamCourses } = useGetAllExamCoursesQuery();
  const examCourseOptions = useMemo(
    () =>
      examCourseData?.reportGetAllExamCourses?.examCourses.map((examCourseItem) => ({
        label: examCourseItem.code,
        value: examCourseItem.id,
      })) ?? [],
    [examCourseData?.reportGetAllExamCourses?.examCourses],
  );

  return (
    <FormSearchSelection
      name={name}
      label='Exam Course'
      loading={isLoadingExamCourses}
      placeholder={placeholder}
      options={examCourseOptions}
    />
  );
}
